module.exports = __webpack_public_path__ + "static/media/96.97244dbf.png";